import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "list", "template", "row" ]

  add() {
    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true))
    const input = this.listTarget.querySelector("[data-custom-attributes-target='row']:last-child input")
    input?.focus()
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest("[data-custom-attributes-target='row']").remove()
    if (this.rowTargets.length === 0) this.add()
  }
}
